import { UserInfo } from '../models';
import MenuStructure from './MenuProvider/MenuStructure';
import { computed } from 'vue';

export function useSiteNavigation(props: Readonly<{ menuItems?: MenuStructure; currentLanguage?: string; isLoggedIn: boolean }>) {
    const currentLanguage = getCurrentLanguage(props);
    const topMenu = computed(() =>
        (props.menuItems?.topMenu?.[currentLanguage.value] || [])
            .filter(m => (props.isLoggedIn ? m.availableForAuthorized : m.availableForAnonymous))
            .map(x => ({
                ...x,
                childPages: x.childPages?.filter(p => (props.isLoggedIn ? p.availableForAuthorized : p.availableForAnonymous))
            }))
    );
    const loginLink = computed(() => props.menuItems?.loginLink?.[currentLanguage.value]);
    const logoutLink = computed(() => props.menuItems?.logoutLink?.[currentLanguage.value]);
    const searchPage = computed(() => props.menuItems?.searchLink?.[currentLanguage.value]);
    const contactUsPage = computed(() => props.menuItems?.contactUsLink?.[currentLanguage.value]);

    return {
        topMenu,
        loginLink,
        logoutLink,
        searchPage,
        contactUsPage
    };
}

export function useProfileNavigation(props: Readonly<{ userInfo?: UserInfo; currentLanguage?: string }>) {
    const profilePageLink = computed(() => props.userInfo?.profilePage?.[getCurrentLanguage(props).value].link);

    return {
        profilePageLink
    };
}

function getCurrentLanguage(props?: { currentLanguage?: string }) {
    return computed(() => props?.currentLanguage ?? 'no');
}
